/**
 * ETML
 * @ De: Theo Bensaci
 * @ Date: 17:54 23.04.2023
 * @ Description: Page de fin du jeux 
 */


import "./index.css";
import React, {useEffect, useRef, useState} from "react";
import GamePageManager from "../../utils/GamePageManager";
import GameAdmin from "../../GameClass/gameAdmin";
import api from "../../utils/api";
import MyButton from "../../compenent/button/MyButton";
import SaveManger from "../../utils/SaveManager";

function FinishScoreDisplay(props){
    return(
        <div className="FinishScoreDisplay">
            <h1>{props.title}</h1>
            <h2>Score : {props.score}</h2>
        </div>
    )
}


export default function GameFinishScreen() {

    const [content, setContent] = useState(null);
    const [isTop10,setIsTop10]=useState(false);
    const [username, setUsername] = useState('');
    const bestStats=useRef(null);

    useEffect(()=>{
        let actualScore=GameAdmin.instance.getStats();
        let finishContent=null;

        // check si il y a un coockie (donc une ancienne run)
        if(bestStats.current!=null)return;
        bestStats.current=SaveManger.data;


        // si pas de pb 
        if(finishContent==null && (actualScore.score>bestStats.current.score || (actualScore.score==bestStats.current.score && actualScore.time<bestStats.current.time))){
            SaveManger.data.score=actualScore.score;
            SaveManger.data.time=actualScore.time;
            SaveManger.save();
            let top10=GameAdmin.instance.checkIfTop10();
            setIsTop10(top10);
            finishContent=(top10)?
            <div className="NewPersonalBest">
                <h2>New Personal Best !</h2>
                <div className="NewTop10">
                    <div className="input">
                        <h3>Enter you username</h3>
                        <input classname="MyTextInput" type="text" value={username} onChange={(e)=>{if(e.target.value.length<11)setUsername(e.target.value)}}/>
                    </div>
                    <FinishScoreDisplay title="" score={actualScore.score} time={new Date((actualScore.time) * 1000).toISOString().slice(14, 19)} />
                </div>
            </div>
            :(
                <div className="NewPersonalBest">
                    <h2>New Personal Best !</h2>
                    <FinishScoreDisplay title="" score={actualScore.score} time={new Date((actualScore.time) * 1000).toISOString().slice(14, 19)} />
                </div>
            );
        }
        else{
            finishContent=(
                <div className="Normal">
                    <FinishScoreDisplay title="Actual Score" score={actualScore.score} time={new Date((actualScore.time) * 1000).toISOString().slice(14, 19)} />
                    <div className="line"></div>
                    <FinishScoreDisplay title="Best Score" score={bestStats.current.score} time={new Date((bestStats.current.time) * 1000).toISOString().slice(14, 19)} />
                </div>
            );
        }
        setContent(finishContent);
    },[username]);

    return (
        <div className="GamePage GameFinishScreen">
            <div className="start"></div>
            <div className="main">
               <h1>{((isTop10)?"Top 10 ":"")}Finish !!</h1>
                {content}
            </div>
            {(isTop10)?
                <div className="end">
                    <div></div>
                    <MyButton title="Ok" fontSize={50} disabel={(username=='')} onClick={()=>{
                        if(username!=""){
                            api.addRecord(GameAdmin.instance.score,GameAdmin.instance.timer,username);
                            GamePageManager.changePage("Top10");
                        }  
                    }} addStyle={{marginBottom:40}}/>
                    <div></div>
                </div>
            :
                <div className="end">
                    <MyButton title="Main Menu" fontSize={30} onClick={()=>GamePageManager.changePage("MainMenu")}/>
                    <MyButton title="Restart" fontSize={30} onClick={()=>GamePageManager.changePage("GameLoading")}/>
                    {(api.isOnline)?<MyButton title="top 10" fontSize={30} onClick={()=>GamePageManager.changePage("Top10")}/>:null}
                </div>
            }
        </div>
    );
}
